<template>
  <div class="round-progress">
    <svg class="round-progress__progress"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 60 60">
      <circle v-if="useCircleBackline"
              fill="transparent"
              stroke-dashoffset="100"
              r="26"
              cx="30"
              cy="30"
              class="round-progress__circle-backline"/>
      <circle ref="circle"
              fill="transparent"
              r="26"
              cx="30"
              cy="30"
              class="round-progress__progress-circle"/>
    </svg>
    <slot>{{number}}</slot>
  </div>
</template>

<script>
  export default {
    name: 'RoundProgress',
    props: {
      percents: {
        type: Number,
        default: 0
      },
      number: {
        type: Number,
        default: 0
      },
      useCircleBackline: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      setCircleProgress(percents) {
        const circle = this.$refs.circle
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;

        circle.style.strokeDasharray = `${circumference} ${circumference}`
        circle.style.strokeDashoffset = circumference - percents / 100 * circumference
      }
    },
    mounted() {
      this.setCircleProgress(this.percents)
    }
  }
</script>

<style lang="less">

</style>
